<template>
	<section class="contact">
		<h2 class="var_mobile">{{ title }}</h2>
		<div v-for="(person, n) in persons" class="row" :key="`person_${n}`">
			<div class="images">
				<img :src="person.image.url" :class="`var_${n % 3}`" alt="" />
			</div>
			<div class="copy_wrapper">
				<h2 v-if="n === 0" class="var_tablet">{{ title }}</h2>
				<div class="copy" v-html="person.text"></div>
				<a
					:href="`mailto:${person.email}`"
					class="email"
					@mouseenter="onPointerMouseEnter($event, 'text')"
					@mouseleave="onPointerMouseLeave($event, 'text')"
					>{{ person.email }}</a
				>
				<a
					:href="`tel:${person.phone}`"
					class="phone"
					@mouseenter="onPointerMouseEnter($event, 'text')"
					@mouseleave="onPointerMouseLeave($event, 'text')"
					>{{ person.phone }}</a
				>
			</div>
		</div>
	</section>
</template>

<script>
import pointerHove from "@/mixins/pointerHover";

export default {
	mixins: [pointerHove],
	props: {
		title: String,
		persons: Array,
	},
};
</script>

<style lang="scss" scoped>
@keyframes border1 {
	0% {
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	}

	25% {
		border-radius: 100% 50% 70% 90% / 90% 100% 60% 80%;
	}

	50% {
		border-radius: 50% 60% 50% 70% / 50% 50% 50% 70%;
	}

	75% {
		// border-radius: 100% 50% 50% 60% / 115% 60% 80% 64%;
		border-radius: 100% 54% 86% 90% / 115% 60% 80% 71%;
	}

	100% {
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	}
}

.contact {
	@include moduleSpacing;
	width: 100%;
	padding-top: 50px;

	.row {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		margin-top: 30px;
		align-items: flex-start;
	}

	h2 {
		@include fontH1;
		letter-spacing: -1px;
		margin-bottom: 20px;

		&.var_mobile {
			display: block;

			@include mq($from: tablet) {
				display: none;
			}
		}

		&.var_tablet {
			display: none;

			@include mq($from: tablet) {
				display: block;
			}
		}

		@include mq($from: tablet) {
			margin-bottom: 40px;
		}
	}

	.copy_wrapper {
		width: 100%;
		margin-top: 20px;

		@include mq($from: m) {
			@include gridColumn(m, 13, 1, false, true);
		}

		@include mq($from: xl) {
			@include gridColumn(xl, 12, 1, false, true);
		}
	}

	.copy {
		@include fontCopy;
		@include textFormat;
		width: 100%;
		margin-bottom: 20px;
	}

	.phone,
	.email {
		@include fontCopy;
		display: block;
		transition: color 0.3s;

		&:hover {
			color: $colorRed1 !important;
		}
	}

	.images {
		display: block;
		width: 100%;

		@include mq($from: m) {
			@include gridColumn(m, 10, 0, false, false);
			position: sticky;
			top: 20px;
		}

		@include mq($from: xl) {
			display: block;
			@include gridColumn(xl, 8, 1, false, false);
		}

		img {
			display: block;
			max-width: 100%;
			border-radius: 70% 60% 50% 100% / 80% 60% 80% 70%;
			animation: border1 12s infinite linear;
			animation-delay: -5;

			&.var_1 {
				border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
				animation: border1 10s infinite linear;

				@include mq($from: desktop) {
					margin-top: -10%;
				}
			}

			&.var_2 {
				border-radius: 100% 50% 70% 90% / 90% 100% 60% 80%;
				animation: border1 10s infinite linear;
				animation-delay: -3;

				@include mq($from: desktop) {
					margin-top: -10%;
				}
			}
		}
	}
}
</style>
